export const startDownload = (downloadPath) => {
  const downloadUrl = `/downloads/${downloadPath}`;
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.toggleAttribute('download', true);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
